import { render, staticRenderFns } from "./InsReq.vue?vue&type=template&id=23c6fb6a&scoped=true&"
import script from "./InsReq.vue?vue&type=script&lang=js&"
export * from "./InsReq.vue?vue&type=script&lang=js&"
import style0 from "./InsReq.vue?vue&type=style&index=0&id=23c6fb6a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c6fb6a",
  null
  
)

export default component.exports